import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAffinityComponent } from './simple-icons-affinity.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAffinityComponent ],
    exports:      [ SimpleIconsAffinityComponent ],
    bootstrap:    []
})
export class SimpleIconsAffinityModule {}
